import { useEffect, useState } from "react";
import { format } from "date-fns";
import "./OrdersDetailsV2.css";
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../hooks/SnackbarProvider";
import {
  getInvoiceDocument,
  getOrderDetails,
  getOrdersStatus,
  payOrderSplit,
  getPaymentStatus,
  updateOrderTimeline,
  completePayment,
  createOrderComment,
  getOrderComments,
} from "../../../../config/Services";
import usePrint from "../hooks/usePrint";
import OrderDetailsNew from "../orders/newOrderDetails";
import BillDrawer from "./Component/BillDrawer";
import PaymentModal from "../all-products/components/twoWaykeyboardPaymentPage/components/paymentModal";
import ManagerPinVerifyModal from "../all-products/components/managerPinVerify";
import { hasPosManagerRole } from "../../../../services/rbacConfig";
import cashNew from "../../../../assets/images/cash-new.png";
import cashNewSelected from "../../../../assets/images/cash-new-selected.png";
import cardNew from "../../../../assets/images/card-new.png";
import cardNewSelected from "../../../../assets/images/card-new-selected.png";
import upiNew from "../../../../assets/images/upi-new.png";
import upiNewSelected from "../../../../assets/images/upi-new-selected.png";
import creditNew from "../../../../assets/images/credit-new.png";
import creditNewSelected from "../../../../assets/images/credit-new-selected.png";
import offlineImg from "../../../../assets/images/offline-icon.png";
import splitNew from "../../../../assets/images/split-new.png";
import splitNewSelected from "../../../../assets/images/split-new-selected.png";
import { getStoreCurrencySymbol } from "../../../../utils/currency";

/* ── Shared SVG icons ── */
const IconArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </svg>
);
const IconChevronRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m9 18 6-6-6-6" />
  </svg>
);
const IconShieldCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const IconClock3 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 6v6h4" />
    <circle cx="12" cy="12" r="10" />
  </svg>
);
const IconCreditCard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" x2="22" y1="10" y2="10" />
  </svg>
);
const IconReceiptText = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
    <path d="M14 8H8" />
    <path d="M16 12H8" />
    <path d="M13 16H8" />
  </svg>
);
const IconCircleCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const IconDotsVertical = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    width="16"
    height="16"
  >
    <circle cx="12" cy="5" r="1.5" />
    <circle cx="12" cy="12" r="1.5" />
    <circle cx="12" cy="19" r="1.5" />
  </svg>
);
const IconSend = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m22 2-7 20-4-9-9-4Z" />
    <path d="M22 2 11 13" />
  </svg>
);

const getISTDate = (dateStr) => {
  if (!dateStr) return null;
  const utcDateStr = dateStr.endsWith("Z")
    ? dateStr
    : dateStr.includes("T")
    ? `${dateStr}Z`
    : `${dateStr} UTC`;
  const d = new Date(utcDateStr);
  const localOffset = new Date().getTimezoneOffset() * 60000;
  return new Date(d.getTime() + localOffset + 5.5 * 60 * 60 * 1000);
};

/* ── B2B order status state machine ── */
const B2B_STATUS_CHAIN = ["CREATED", "PACKAGED", "IN_TRANSIT", "DELIVERED"];
const STATUS_LABELS = {
  PACKAGED: "Mark as Packaged",
  IN_TRANSIT: "Mark as In-Transit",
  DELIVERED: "Mark as Delivered",
};
const getNextB2bStatus = (current) => {
  const idx = B2B_STATUS_CHAIN.indexOf(current);
  return idx >= 0 && idx < B2B_STATUS_CHAIN.length - 1 ? B2B_STATUS_CHAIN[idx + 1] : null;
};

/* ── Safe timeline time (handles ISO and pre-formatted B2B strings) ── */
const renderTimelineTime = (updateAt) => {
  if (!updateAt) return "N/A";
  try {
    const d = getISTDate(updateAt);
    if (d && !isNaN(d.getTime())) return format(d, "dd MMM, yyyy h:mm aa");
  } catch {}
  return updateAt; // already formatted (e.g. "1 August, 2026, 06:16:17.809")
};

/* ── Shared Order Summary + Payment (rendered in every tab) ── */
const OrderSummaryAndPayment = ({ orderDetails }) => {
  const billing = orderDetails?.orderBillingDetails;
  const payments = orderDetails?.orderBillingDetails?.payments || [];
  return (
    <>
      <section className="od-panel" aria-label="Order summary">
        <h3 className="od-panel-title">Order Summary</h3>
        <dl className="od-summary-grid">
          {[
            { id: "subtotal", label: "Subtotal", value: `${getStoreCurrencySymbol()}${billing?.subTotal || 0}` },
            { id: "discount", label: "Discount", value: `${getStoreCurrencySymbol()}${billing?.totalDiscount || 0}` },
            { id: "tax", label: "Tax", value: `${getStoreCurrencySymbol()}${billing?.tax || 0}` },
            { id: "handling", label: "Handling", value: `${getStoreCurrencySymbol()}${billing?.handlingCharges || 0}` },
            {
              id: "refund",
              label: "Refund",
              value: `${getStoreCurrencySymbol()}${orderDetails?.returnDetails?.refundAmount || 0}`,
            },
          ]?.map((row) => (
            <div key={row?.id} className="od-summary-row" data-testid={`row-summary-${row?.id}`}>
              <span>{row?.label}</span>
              <span>{row?.value}</span>
            </div>
          ))}
        </dl>
        <hr className="od-summary-divider" />
        <div className="od-summary-total-row">
          <span className="od-summary-total-label">Grand Total</span>
          <span className="od-summary-total-amount" data-testid="text-summary-grand-total">
            {getStoreCurrencySymbol()}{billing?.grandTotal || 0}
          </span>
        </div>
      </section>

      <section className="od-payment-card" aria-label="Payment details">
        {payments?.length > 0 ? (
          payments?.map((payment, index) => (
            <div
              key={payment?.paymentId || index}
              className="od-payment-inner"
              data-testid={`card-payment-${payment?.paymentId || index}`}
            >
              <div>
                <p className="od-payment-id">{`Transaction ID: ${payment?.paymentId || "NA"}`}</p>
                <p className="od-payment-sub">{`Date: ${
                  payment?.paymentDate
                    ? format(getISTDate(payment?.paymentDate), "dd MMM, yyyy")
                    : "NA"
                } · Payment Method: ${payment?.paymentMethod || "NA"}`}</p>
              </div>
              <div className="od-payment-right">
                <p
                  className="od-payment-amount"
                  data-testid={`text-payment-amount-${payment?.paymentId || index}`}
                >
                  {getStoreCurrencySymbol()}{payment?.amountPaid ?? 0}
                </p>
                <span className="od-badge od-badge--settled">{payment?.paymentStatus || "NA"}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="od-payment-inner">
            <p className="od-payment-id">No payment records</p>
          </div>
        )}
      </section>
    </>
  );
};

/* ══════════════════════════════════════════
   TAB CONTENT COMPONENTS
══════════════════════════════════════════ */

/* Tab 1 — Order Details */
const TabOrderDetails = ({ orderDetails }) => {
  const rows = orderDetails?.baseOrderResponse?.lineItems || [];
  return (
    <>
      <section className="od-tab-content" aria-label="Order line items">
        <section className="od-table-scroll">
          <div className="od-grid-table od-cols-order-details">
            <header className="od-grid-table-head od-cols-order-details" role="rowgroup">
              <div className="od-grid-th" role="columnheader">
                Item
              </div>
              <div className="od-grid-th" role="columnheader">
                Barcode
              </div>
              <div className="od-grid-th" role="columnheader">
                HSN
              </div>
              <div className="od-grid-th" role="columnheader">
                Rate
              </div>
              <div className="od-grid-th" role="columnheader">
                Quantity
              </div>
              <div className="od-grid-th" role="columnheader">
                {"Quantity fulfilled"}
              </div>
              <div className="od-grid-th" role="columnheader">
                MRP rate
              </div>
              <div className="od-grid-th" role="columnheader">
                Amount
              </div>
            </header>
            <div className="od-grid-table-body od-items-body-scroll" role="rowgroup">
              {rows?.map((item) => (
                <article
                  key={item?.orderItemId}
                  className="od-grid-table-row od-cols-order-details"
                >
                  <span className="od-grid-td od-grid-td--name">{item?.productName}</span>

                  <span className="od-grid-td">{item?.gtin || "-"}</span>

                  <span className="od-grid-td">{item?.hsnCode || "-"}</span>

                  <span className="od-grid-td">{getStoreCurrencySymbol()}{item?.sellingPrice}</span>

                  <span className="od-grid-td">{item?.quantityBySpecs}</span>

                  <span className="od-grid-td">{item?.quantityReceived}</span>

                  <span className="od-grid-td">{getStoreCurrencySymbol()}{item?.mrp}</span>

                  <span className="od-grid-td od-grid-td--amount">{getStoreCurrencySymbol()}{item?.subTotal}</span>
                </article>
              ))}
            </div>
          </div>
        </section>
      </section>
      <OrderSummaryAndPayment orderDetails={orderDetails} />
    </>
  );
};

/* Tab 2 — Discount */
const TabDiscount = ({ orderDetails }) => {
  const rows = orderDetails?.discountDetails?.discounts || [];
  const totalDiscount = orderDetails?.discountDetails?.totalDiscount ?? 0;

  return (
    <>
      <section className="od-tab-content" aria-label="Item discount breakdown">
        <header className="od-tab-panel-header">
          <h3 className="od-tab-panel-header-title">Item discount breakdown</h3>
        </header>

        <section className="od-table-scroll">
          <div className="od-grid-table od-cols-discount">
            <div className="od-grid-table-head od-cols-discount" role="rowgroup">
              <div className="od-grid-th" role="columnheader">
                Item
              </div>
              <div className="od-grid-th" role="columnheader">
                Barcode
              </div>
              <div className="od-grid-th" role="columnheader">
                Base amount
              </div>
              <div className="od-grid-th" role="columnheader">
                Discount type
              </div>
              <div className="od-grid-th" role="columnheader">
                Discount value
              </div>
              <div className="od-grid-th" role="columnheader">
                Net amount
              </div>
            </div>
            <div className="od-grid-table-body" role="rowgroup">
              {totalDiscount === 0 ? (
                <div className="od-empty-state">
                  <p className="od-empty-state-title">No discounts applied</p>
                  <p className="od-empty-state-sub">This order has no discount records</p>
                </div>
              ) : (
                rows?.map((item, index) => (
                  <article
                    key={item?.orderItemId || index}
                    className="od-grid-table-row od-cols-discount"
                    role="row"
                  >
                    <span className="od-grid-td od-grid-td--name" role="cell">
                      {item?.productName || "-"}
                    </span>

                    <span className="od-grid-td" role="cell">
                      {item?.gtin || "-"}
                    </span>

                    <span className="od-grid-td" role="cell">
                      {getStoreCurrencySymbol()}{item?.baseAmount || 0}
                    </span>

                    <span className="od-grid-td" role="cell">
                      {item?.discountType || "-"}
                    </span>

                    <span className="od-grid-td od-grid-td--discount" role="cell">
                      {getStoreCurrencySymbol()}{item?.discountValue || 0}
                    </span>

                    <span className="od-grid-td od-grid-td--amount" role="cell">
                      {getStoreCurrencySymbol()}{item?.netAmount || 0}
                    </span>
                  </article>
                ))
              )}
            </div>
          </div>
        </section>
      </section>
      <OrderSummaryAndPayment orderDetails={orderDetails} />
    </>
  );
};

/* Tab 3 — Detailed View */
const TabDetailedView = ({ orderDetails }) => {
  const stats = [
    {
      label: "Invoice status",
      value: "Delivered",
      sub: `Invoice ID: ${orderDetails?.baseOrderResponse?.invoiceId || "NA"}`,
    },
    {
      label: "Fulfillment",
      value: orderDetails?.baseOrderResponse?.fulFilment || "0",
      sub: "Promise date 31 Mar, 2026",
    },
    {
      label: "Payment follow-up",
      value: orderDetails?.orderBillingDetails?.paymentMethod || "NA",
      sub: `Mode: ${orderDetails?.orderBillingDetails?.paymentMode || "NA"} `,
    },
  ];

  return (
    <>
      <section className="od-stat-grid" aria-label="Detailed order view">
        {stats?.map((s) => (
          <article key={s?.label} className="od-stat-card">
            <p className="od-stat-card-label">{s?.label}</p>
            <p className="od-stat-card-value">{s?.value}</p>
            <p className="od-stat-card-sub">{s?.sub}</p>
          </article>
        ))}
      </section>
      <OrderSummaryAndPayment orderDetails={orderDetails} />
    </>
  );
};

/* Tab 4 — Shipment */
const TabShipment = ({ orderDetails }) => (
  <>
    <section className="od-two-col-grid" aria-label="Shipment details">
      <article className="od-info-card">
        <h3 className="od-info-card-title">Shipment overview</h3>
        <dl className="od-kv-list">
          {[
            {
              label: "Shipment",
              value: orderDetails?.poInfo?.shipment || "N/A",
            },
            {
              label: "Shipment date",
              value: orderDetails?.poInfo?.shipmentDate || "N/A",
            },
            { label: "Promise date", value: "31 Mar, 2026" },
            {
              label: "Channel",
              value: orderDetails?.baseOrderResponse?.salesChannel || "N/A",
            },
          ]?.map((kv) => (
            <div key={kv?.label} className="od-kv-row">
              <dt>{kv?.label}</dt>
              <p>
                <span>{kv?.value}</span>
              </p>
            </div>
          ))}
        </dl>
      </article>

      <article className="od-info-card">
        <h3 className="od-info-card-title">Delivery addresses</h3>
        <div className="od-addr-list">
          {[
            {
              type: "Billing",
              addr: `${orderDetails?.addressEntityModel?.billingAddress?.addressLine1 || ""}
  ${orderDetails?.addressEntityModel?.billingAddress?.addressLine2 || ""}
  ${orderDetails?.addressEntityModel?.billingAddress?.city || ""}
  ${orderDetails?.addressEntityModel?.billingAddress?.state || ""}
  ${orderDetails?.addressEntityModel?.billingAddress?.pinCode || ""}`,
            },
            {
              type: "Shipping",
              addr: `${orderDetails?.addressEntityModel?.shippingAddress?.addressLine1 || ""}
  ${orderDetails?.addressEntityModel?.shippingAddress?.addressLine2 || ""}
  ${orderDetails?.addressEntityModel?.shippingAddress?.city || ""}
  ${orderDetails?.addressEntityModel?.shippingAddress?.state || ""}
  ${orderDetails?.addressEntityModel?.shippingAddress?.pinCode || ""}`,
            },
          ]?.map((a) => (
            <address key={a?.type}>
              <p className="od-addr-block-name">{a?.type}</p>
              <p className="od-addr-block-text">{a?.addr}</p>
            </address>
          ))}
        </div>
      </article>
    </section>
    <OrderSummaryAndPayment orderDetails={orderDetails} />
  </>
);

/* Tab 5 — Review */
const TabReview = ({ orderDetails }) => (
  <>
    <section className="od-review-grid" aria-label="Order review">
      <article className="od-review-card">
        <h3 className="od-review-card-label">Operational note</h3>
        <p className="od-review-card-text" data-testid="text-review-primary">
          {/* Order was processed successfully with full item fulfillment and payment settlement
          completed on schedule. */}
          NA
        </p>
      </article>
      <article className="od-review-card">
        <h3 className="od-review-card-label">Resolution / QA</h3>
        <p className="od-review-card-text" data-testid="text-review-secondary">
          {/* No shipment exception detected. Billing and shipping addresses were matched, and invoice
          copy was generated without manual intervention. */}
          NA
        </p>
      </article>
    </section>
    <OrderSummaryAndPayment orderDetails={orderDetails} />
  </>
);

/* Tab 6 — GST & B2B Details (shown only for SALES_ORDER) */
/* Safe formatter — handles both number and string values from the API */
const fmt = (v) => (v != null ? parseFloat(v).toFixed(2) : "—");

const TabGSTDetails = ({ orderDetails }) => {
  const billing = orderDetails?.orderBillingDetails;
  const billingAddr = orderDetails?.addressEntityModel?.billingAddress;
  const shippingAddr = orderDetails?.addressEntityModel?.shippingAddress;
  const rawGstBreakup = (orderDetails?.gstBreakupDetails || []).filter((r) => r?.gstRate != null);
  const customTaxes = [];
  if (Array.isArray(billing?.taxes) && billing.taxes.length > 0) {
    billing.taxes.forEach((tax) => {
      if (Array.isArray(tax?.rates) && tax.rates.length > 0) {
        tax.rates.forEach((r) => {
          customTaxes.push({
            slabLabel: `${tax?.taxName || "Tax"} (${r?.rate ?? 0}%)`,
            gstRate: r?.rate,
            taxableAmt: r?.taxableAmount ?? tax?.totalTaxableAmount ?? 0,
            cgst: tax?.taxName === "CGST" ? r?.taxAmount : null,
            sgst: tax?.taxName === "SGST" ? r?.taxAmount : null,
            cess: 0,
            totalAmt:
              (r?.taxableAmount ?? tax?.totalTaxableAmount ?? 0) +
              (r?.taxAmount ?? tax?.totalTaxAmount ?? 0),
          });
        });
      } else {
        customTaxes.push({
          slabLabel: `${tax?.taxName || "Tax"}${tax?.rate != null ? ` (${tax.rate}%)` : ""}`,
          gstRate: tax?.rate,
          taxableAmt: tax?.totalTaxableAmount ?? 0,
          cgst: tax?.taxName === "CGST" ? tax?.totalTaxAmount : null,
          sgst: tax?.taxName === "SGST" ? tax?.totalTaxAmount : null,
          cess: 0,
          totalAmt: (tax?.totalTaxableAmount ?? 0) + (tax?.totalTaxAmount ?? 0),
        });
      }
    });
  }
  const gstBreakup = customTaxes.length > 0 ? customTaxes : rawGstBreakup;
  const rawGstItems = orderDetails?.gstWiseOrderItems || {};
  // Normalise: values can be an array or an object with an `items` key
  const gstItems = Object.fromEntries(
    Object.entries(rawGstItems)?.filter(([, v]) => Array.isArray(v))
  );

  const formatAddr = (a) =>
    a
      ? [a?.addressLine1, a?.addressLine2, a?.city, a?.state, a?.pinCode].filter(Boolean).join(", ")
      : "—";

  return (
    <>
      {/* ── Partner & Addresses ── */}
      <section className="od-tab-content" aria-label="B2B partner details">
        <div className="od-b2b-addr-grid">
          {/* Customer info */}
          <article className="od-info-card">
            <h3 className="od-info-card-title">B2B Partner</h3>
            <dl className="od-kv-list">
              {[
                {
                  label: "Company name",
                  value: orderDetails?.baseOrderResponse?.customerName || "—",
                },
                {
                  label: "Phone",
                  value: orderDetails?.baseOrderResponse?.mobileNumber || "—",
                },
                {
                  label: "Partner ID",
                  value: orderDetails?.baseOrderResponse?.sourceId || "—",
                },
                {
                  label: "Source App",
                  value: orderDetails?.baseOrderResponse?.sourceApp || "—",
                },
              ].map((kv) => (
                <div key={kv?.label} className="od-kv-row">
                  <dt>{kv?.label}</dt>
                  <dd>{kv?.value}</dd>
                </div>
              ))}
            </dl>
          </article>

          {/* Billing address */}
          <article className="od-info-card">
            <h3 className="od-info-card-title">Billing Address</h3>
            <address className="od-b2b-addr-block">
              <p>{formatAddr(billingAddr)}</p>
              {billingAddr?.phoneNo && (
                <p className="od-b2b-addr-phone">☎ {billingAddr.phoneNo}</p>
              )}
              {billingAddr?.gstin && (
                <p className="od-b2b-addr-gstin">GSTIN: {billingAddr?.gstin}</p>
              )}
            </address>
          </article>

          {/* Shipping address */}
          <article className="od-info-card">
            <h3 className="od-info-card-title">Shipping Address</h3>
            <address className="od-b2b-addr-block">
              <p>{formatAddr(shippingAddr)}</p>
              {shippingAddr?.phoneNo && (
                <p className="od-b2b-addr-phone">☎ {shippingAddr?.phoneNo}</p>
              )}
            </address>
          </article>
        </div>
      </section>

      {/* ── GST Breakup table ── */}
      <section className="od-tab-content" aria-label="GST breakup">
        <header className="od-tab-panel-header">
          <h3 className="od-tab-panel-header-title">GST Breakup</h3>
        </header>
        <section className="od-table-scroll">
          <div className="od-grid-table od-cols-gst">
            <div className="od-grid-table-head od-cols-gst" role="rowgroup">
              {["GST Slab", "Taxable Amount", "CGST", "SGST", "Cess", "Total"].map((h) => (
                <div key={h} className="od-grid-th" role="columnheader">
                  {h}
                </div>
              ))}
            </div>
            <div className="od-grid-table-body" role="rowgroup">
              {gstBreakup?.length === 0 ? (
                <div className="od-empty-state">
                  <p className="od-empty-state-title">No GST breakup available</p>
                </div>
              ) : (
                gstBreakup?.map((row, i) => (
                  <article key={i} className="od-grid-table-row od-cols-gst" role="row">
                    <span className="od-grid-td od-gst-slab-badge" role="cell">
                      {row?.slabLabel || (row?.gstRate != null ? `${row?.gstRate}%` : "—")}
                    </span>
                    <span className="od-grid-td" role="cell">
                      {getStoreCurrencySymbol()}{fmt(row?.taxableAmt)}
                    </span>
                    <span className="od-grid-td" role="cell">
                      {getStoreCurrencySymbol()}{fmt(row?.cgst)}
                    </span>
                    <span className="od-grid-td" role="cell">
                      {getStoreCurrencySymbol()}{fmt(row?.sgst)}
                    </span>
                    <span className="od-grid-td" role="cell">
                      {getStoreCurrencySymbol()}{fmt(row?.cess)}
                    </span>
                    <span className="od-grid-td od-grid-td--amount" role="cell">
                      {getStoreCurrencySymbol()}{fmt(row?.totalAmt)}
                    </span>
                  </article>
                ))
              )}
            </div>
          </div>
        </section>

        {/* GST totals row */}
        {gstBreakup?.length > 0 && (
          <div className="od-gst-totals-row">
            <span>Total</span>
            <span>{getStoreCurrencySymbol()}{fmt(billing?.subTotal)}</span>
            <span>{getStoreCurrencySymbol()}{fmt(billing?.cgst)}</span>
            <span>{getStoreCurrencySymbol()}{fmt(billing?.sgst)}</span>
            <span>{getStoreCurrencySymbol()}{fmt(billing?.cess)}</span>
            <span>{getStoreCurrencySymbol()}{fmt(billing?.grandTotal)}</span>
          </div>
        )}
      </section>

      {/* ── Items by GST slab ── */}
      {Object.keys(gstItems)?.length > 0 && (
        <section className="od-tab-content" aria-label="Items by GST slab">
          <header className="od-tab-panel-header">
            <h3 className="od-tab-panel-header-title">Items by GST Slab</h3>
          </header>
          {Object.entries(gstItems)?.map(([slab, items]) => (
            <div key={slab} className="od-gst-slab-group">
              <div className="od-gst-slab-label">
                <span className="od-gst-slab-badge">{slab}</span>
              </div>
              <section className="od-table-scroll">
                <div className="od-grid-table od-cols-gst-items">
                  <div className="od-grid-table-head od-cols-gst-items" role="rowgroup">
                    {[
                      "Item",
                      "HSN",
                      "Rate",
                      "Qty",
                      "CGST%",
                      "SGST%",
                      `CGST (${getStoreCurrencySymbol()})`,
                      `SGST (${getStoreCurrencySymbol()})`,
                      "Amount",
                    ]?.map((h) => (
                      <div key={h} className="od-grid-th" role="columnheader">
                        {h}
                      </div>
                    ))}
                  </div>
                  <div className="od-grid-table-body" role="rowgroup">
                    {items?.map((item) => (
                      <article
                        key={item?.orderItemId}
                        className="od-grid-table-row od-cols-gst-items"
                        role="row"
                      >
                        <span className="od-grid-td od-grid-td--name" role="cell">
                          {item?.productName}
                        </span>
                        <span className="od-grid-td" role="cell">
                          {item?.hsnCode || "—"}
                        </span>
                        <span className="od-grid-td" role="cell">
                          {getStoreCurrencySymbol()}{item?.sellingPrice}
                        </span>
                        <span className="od-grid-td" role="cell">
                          {item?.quantityBySpecs || item?.quantity}
                        </span>
                        <span className="od-grid-td" role="cell">
                          {item?.cgst}%
                        </span>
                        <span className="od-grid-td" role="cell">
                          {item?.sgst}%
                        </span>
                        <span className="od-grid-td" role="cell">
                          {getStoreCurrencySymbol()}{fmt(item?.cgstAmount)}
                        </span>
                        <span className="od-grid-td" role="cell">
                          {getStoreCurrencySymbol()}{fmt(item?.sgstAmount)}
                        </span>
                        <span className="od-grid-td od-grid-td--amount" role="cell">
                          {getStoreCurrencySymbol()}{item?.subTotal}
                        </span>
                      </article>
                    ))}
                  </div>
                </div>
              </section>
            </div>
          ))}
        </section>
      )}

      <OrderSummaryAndPayment orderDetails={orderDetails} />
    </>
  );
};

/* ══════════════════════════════════════════
   TABS CONFIG
══════════════════════════════════════════ */
const BASE_TABS = [
  {
    id: "order-details",
    label: "Order details",
    testId: "button-record-tab-order-details",
    Component: TabOrderDetails,
  },
  {
    id: "discount",
    label: "Discount",
    testId: "button-record-tab-discount",
    Component: TabDiscount,
  },
  {
    id: "detailed-view",
    label: "Detailed view",
    testId: "button-record-tab-detailed-view",
    Component: TabDetailedView,
  },
  {
    id: "shipment",
    label: "Shipment",
    testId: "button-record-tab-shipment",
    Component: TabShipment,
  },
];

const B2B_TAB = {
  id: "gst-details",
  label: "GST & B2B",
  testId: "button-record-tab-gst-details",
  Component: TabGSTDetails,
};

/* ══════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════ */
const OrdersDetailsV2 = () => {
  const pathParams = useParams();
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();

  // state
  const [activeTab, setActiveTab] = useState("order-details");
  const [viewBillOpen, setViewBillOpen] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);
  const [invoiceBlobUrl, setInvoiceBlobUrl] = useState(null);
  const [invoiceViewerOpen, setInvoiceViewerOpen] = useState(false);

  const locId = localStorage.getItem("locId");
  const { startPrint, printToken, openDrawer } = usePrint();

  //  states

  const [orderDetails, setOrderDetails] = useState({});
  const [orderTimeLine, setOrderTimeLine] = useState({});
  const [loading, setLoading] = useState(true); // default true so first paint shows the spinner

  // B2B / SALES_ORDER detection — must come AFTER orderDetails state is declared
  const isSalesOrder =
    orderDetails?.baseOrderResponse?.orderType === "SALES_ORDER" ||
    orderDetails?.baseOrderResponse?.sourceApp === "PALLET_RETAIL";

  const TABS = isSalesOrder ? [...BASE_TABS, B2B_TAB] : BASE_TABS;
  const ActiveComponent = TABS?.find((t) => t?.id === activeTab)?.Component ?? TabOrderDetails;

  const [isReprinting, setIsReprinting] = useState(false);
  const [isKotReprinting, setIsKotReprinting] = useState(false);

  // B2B: status change action menu
  const [b2bMenuOpen, setB2bMenuOpen] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState(false);

  // B2B: comments
  const [orderComments, setOrderComments] = useState([]);
  const [commentInput, setCommentInput] = useState("");
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [submittingComment, setSubmittingComment] = useState(false);

  // Payment modal states
  const [openPayModal, setOpenPayModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("CASH");
  const [enterAmount, setEnterAmount] = useState("");
  const [paymentLoader, setpaymentLoader] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentLoadingModal, setPaymentLoadingModal] = useState(false);
  const [paymentCancel, setPaymentCancel] = useState(false);
  const [amountPaid, setAmountPaid] = useState("0");
  const [amountDue, setAmountDue] = useState("0");
  const [partialStatus, setPartailStatus] = useState(false);
  const [splitActive, setSplitActive] = useState(false);
  const [singleOrderoffline, setSingleOrderOffline] = useState(false);
  const [newTransId, setNewTransId] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [payLoader, setPayLoader] = useState(false);
  const [cashChange, setCashChange] = useState(false);
  const [functionCalled, setFunctionCalled] = useState(false);
  const [cardFunctionCalled, setCardFunctionCalled] = useState(false);
  const [splitFunctionCalled, setSplitFunctionCalled] = useState(false);
  const [manual, setManaul] = useState(false);
  const [transCode, setTransCode] = useState("");
  const [approveloader, setApproveLoader] = useState(false);
  const [cancelLoader, setCancelLoader] = useState(false);
  /* ── Forced-offline payment (from order details Pay button) ── */
  const [forceOfflineMode, setForceOfflineMode] = useState(false);
  const [showManagerPinGate, setShowManagerPinGate] = useState(false);
  // const storeMode = localStorage.getItem("storeMode");
  const storeMode = localStorage.getItem("cartStoreMode");
  const machineId = localStorage.getItem("machineId");
  const failedImgWarning = "https://icon-library.net/images/failed-icon/failed-icon-8.jpg";
  const cancelGif =
    "https://cdn0.iconfinder.com/data/icons/banking-156/60/cancel__delete__payment__card__credit-512.png";
  const branchSubType = localStorage.getItem("branchSubType");
  const retailType = localStorage.getItem("retailType");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");

  const fetchgetOrderDetailsFn = async (showLoader = false) => {
    try {
      if (showLoader) setLoading(true);
      const [orderDetailsResponse, orderTimelineResponse] = await Promise.all([
        getOrderDetails(pathParams?.id, locId),
        getOrdersStatus(pathParams?.id),
      ]);

      if (orderDetailsResponse?.data?.code === "ECONNRESET") {
        showSnackbar(orderDetailsResponse?.data?.message || "socket hangup");
      }
      if (orderTimelineResponse?.data?.code === "ECONNRESET") {
        showSnackbar(orderTimelineResponse?.data?.message || "socket hangup", "error");
      }

      setOrderDetails(orderDetailsResponse?.data?.data || {});
      setOrderTimeLine(orderTimelineResponse?.data?.data || {});
    } catch (err) {
      showSnackbar("failed to fetch orders", "error");
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  useEffect(() => {
    fetchgetOrderDetailsFn(true);
  }, []);

  // Keep amountPaid in sync with the loaded order details.
  // Without this, amountPaid stays at its "0" initial value when navigating to
  // an already-paid B2B order, causing paymentCompleted to be false and the
  // View Invoice button to remain permanently disabled.
  useEffect(() => {
    const paid = orderDetails?.orderBillingDetails?.amountPaid;
    if (paid != null) setAmountPaid(paid);
  }, [orderDetails]);

  // Fetch comments whenever the order is identified as B2B
  useEffect(() => {
    if (isSalesOrder && pathParams?.id) fetchOrderComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSalesOrder]);

  // Payment related functions
  const handleOpenPaymentModal = () => {
    const outstandingAmount =
      orderDetails?.orderBillingDetails?.grandTotal -
      (orderDetails?.orderBillingDetails?.amountPaid || 0);
    setAmountDue(outstandingAmount);
    setAmountPaid(orderDetails?.orderBillingDetails?.amountPaid || 0);
    setPartailStatus(true);

    const alreadyOffline = storeMode === "OFFLINE" || !machineId;

    if (alreadyOffline || hasPosManagerRole()) {
      /* Store is already offline, OR user has manager role — no PIN needed */
      setForceOfflineMode(true);
      setOpenPayModal(true);
    } else {
      /* Online store + non-manager — require manager PIN before proceeding */
      setShowManagerPinGate(true);
    }
  };

  const resetPaymentValues = () => {
    setPaymentLoadingModal(false);
    setSingleOrderOffline(false);
    setSplitActive(false);
    setEnterAmount("");
    setPayLoader(false);
    setCashChange(false);
    setPartailStatus(false);
    setAmountPaid("");
    setPaymentMethod("CASH");
    setForceOfflineMode(false);
  };

  const closePaymentModal = () => {
    setOpenPayModal(false);
    resetPaymentValues();
  };

  const handleSplitPayment = () => {
    setPaymentMethod("CASH");
    setSplitActive(true);
  };

  const handleOffline = () => {
    setSingleOrderOffline(true);
  };

  const handleManual = () => {
    setManaul(true);
  };

  const clrAmountFun = () => setEnterAmount("");

  const handlesplitInputChange = (e) => {
    const valueInput = e.target.value;
    setEnterAmount(valueInput);
  };

  const callPaymentStatus = (transId, currentRetry) => {
    let maxRetries = 95;
    let retry = currentRetry || 0;

    getPaymentStatus(transId)
      .then((res) => {
        if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_INITIATED" &&
          retry < maxRetries
        ) {
          retry++;
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          setPaymentLoadingModal(true);
          setpaymentLoader(true);
          setPaymentSuccess(false);
          setTimeout(() => callPaymentStatus(transId, retry), 2000 + retry);
          if (retry === maxRetries) {
            setPaymentFailed(true);
          }
        } else if (res?.data?.data?.paymentResponseModel?.paymentStatus === "COMPLETED") {
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          setPaymentSuccess(true);
          setpaymentLoader(false);
          setTimeout(() => {
            closePaymentModal();
            fetchgetOrderDetailsFn();
          }, 2000);
        } else if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_CANCELLED" ||
          res?.data?.data?.paymentResponseModel?.paymentStatus === "CANCELLED"
        ) {
          retry = maxRetries;
          setPaymentLoadingModal(false);
          setCancelLoader(false);
          setpaymentLoader(false);
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "error");
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  const partialCompletePayment = () => {
    if (!pathParams?.id) {
      showSnackbar("Order ID is missing. Please try again.", "error");
      return;
    }

    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    const sessionId = localStorage.getItem("sessionId");
    const licenseId = localStorage.getItem("licenseId");
    const uidx = retailUserDetails?.uidx;

    const change = (Number(enterAmount) - Number(amountDue)).toFixed(2);

    let payload = {
      orderId: pathParams?.id,
      ...(splitActive && { paymentType: "SPLIT" }),
      amount: splitActive || paymentMethod === "CASH" ? enterAmount : amountDue,
      paymentMethod: paymentMethod,
      paymentMode:
        forceOfflineMode || singleOrderoffline || storeMode === "OFFLINE" || !machineId
          ? "OFFLINE"
          : "ONLINE",
      licenseId: licenseId,
      sessionId: sessionId,
      loggedInUserId: uidx,
      machineCode: machineId,
      tender: enterAmount,
      balance: String(Math.abs(change)),
    };

    setModalLoader(true);

    payOrderSplit(payload)
      .then((res) => {
        setPaymentLoadingModal(true);
        if (res?.data?.data?.es === 1) {
          showSnackbar(res?.data?.data?.message, "error");
          setModalLoader(false);
          return;
        }

        if (res?.data?.data?.paymentStatus === "COMPLETED") {
          setPaymentFailed(false);
          setPaymentSuccess(true);
          setpaymentLoader(true);

          if (paymentMethod === "CASH") {
            openDrawer();
          }

          showSnackbar("Payment Success", "success");
          setTimeout(() => {
            closePaymentModal();
            fetchgetOrderDetailsFn();
          }, 2000);
        } else if (
          res?.data?.data?.paymentStatus === "PARTIALLY_PAID" ||
          res?.data?.data?.paymentStatus === "PAYMENT_PENDING" ||
          res?.data?.data?.paymentStatus === "PAYMENT_CANCELLED"
        ) {
          if ((paymentMethod === "CARD" || paymentMethod === "UPI") && storeMode === "ONLINE") {
            setPaymentLoadingModal(true);
            setNewTransId(res?.data?.data?.transactionCode);
            callPaymentStatus(res?.data?.data?.transactionCode);
          }
          setPaymentLoadingModal(false);
          setCashChange(true);
          showSnackbar(res?.data?.data?.paymentStatus, "success");
          setEnterAmount("");
          setAmountPaid(res?.data?.data?.amountPaid);
          setAmountDue(res?.data?.data?.amountToBePaid);
          setPayLoader(false);
          setModalLoader(false);
        } else {
          setPayLoader(false);
          setPaymentLoadingModal(false);
          setModalLoader(false);
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setPayLoader(false);
        setCashChange(false);
        setModalLoader(false);
      });
  };

  const showPayButton = () => {
    const orderStatus = orderDetails?.baseOrderResponse?.orderStatus;
    if (retailType === "RESTAURANT" && branchSubType === "FINE_DINE") {
      if (
        orderStatus === "PARTIALLY_PAID" ||
        (orderStatus === "PAYMENT_PENDING" &&
          orderDetails?.orderBillingDetails?.paymentMethod !== "CREDIT_NOTE")
      ) {
        return true;
      }
    } else {
      if (orderStatus === "CREATED" || orderStatus === "PARTIALLY_PAID") {
        return true;
      }
    }
    return false;
  };

  const isShowPayButton = showPayButton();

  // ── B2B helpers ──────────────────────────────────────────────
  const b2bUserName =
    retailUserDetails?.name ||
    retailUserDetails?.userName ||
    localStorage.getItem("userName") ||
    "Staff";
  const currentOrderStatus = orderDetails?.baseOrderResponse?.orderStatus;

  // Derive the current FULFILLMENT stage from the order timeline.
  // The payment API (/payments/v1/record) causes the server to set orderStatus to
  // "PAYMENT_COMPLETED", overwriting the fulfillment stage in the response. We recover
  // the true fulfillment position by walking the timeline in reverse and returning the
  // last entry whose fulfilmentStatus is one of the four B2B fulfillment steps.
  const FULFILLMENT_STATUS_SET = new Set(B2B_STATUS_CHAIN); // CREATED/PACKAGED/IN_TRANSIT/DELIVERED
  const currentFulfillmentStatus = (() => {
    const timeline = orderTimeLine?.timeLine || [];
    for (let i = timeline.length - 1; i >= 0; i--) {
      const s = (timeline[i]?.fulfilmentStatus || "").toUpperCase().replace(/-/g, "_").trim();
      if (FULFILLMENT_STATUS_SET.has(s)) return s;
    }
    // Fallback: orderStatus itself if it is a valid fulfillment step (first load, before payment)
    return FULFILLMENT_STATUS_SET.has(currentOrderStatus) ? currentOrderStatus : "CREATED";
  })();

  const nextB2bStatus = getNextB2bStatus(currentFulfillmentStatus);

  // For B2B/Sales Orders, the status chain is CREATED→PACKAGED→IN_TRANSIT→DELIVERED
  // and never reaches "PAYMENT_COMPLETED". Payment is tracked separately via amountPaid.
  // Invoice becomes available as soon as any payment has been recorded (amountPaid > 0).
  const paymentCompleted = isSalesOrder
    ? parseFloat(amountPaid) > 0
    : currentOrderStatus === "PAYMENT_COMPLETED";

  // Payment can be recorded at any fulfillment stage — it's independent of delivery status.

  const handleUpdateStatus = async (newStatus) => {
    setStatusUpdating(true);
    setB2bMenuOpen(false);
    try {
      await updateOrderTimeline({
        orderId: pathParams?.id,
        orderStatus: newStatus,
        updatedBy: b2bUserName,
      });
      showSnackbar(`Status updated to ${newStatus.replace(/_/g, " ")}`, "success");
      fetchgetOrderDetailsFn(false);
    } catch (e) {
      showSnackbar(e?.response?.data?.message || "Failed to update status", "error");
    } finally {
      setStatusUpdating(false);
    }
  };

  const fetchOrderComments = async () => {
    setCommentsLoading(true);
    try {
      const res = await getOrderComments(pathParams?.id);
      setOrderComments(res?.data?.data?.comments || []);
    } catch {
    } finally {
      setCommentsLoading(false);
    }
  };

  const handleSubmitComment = async () => {
    if (!commentInput.trim()) return;
    setSubmittingComment(true);
    try {
      await createOrderComment({
        orderId: pathParams?.id,
        createdBy: b2bUserName,
        commentType: "ORDER",
        comment: commentInput.trim(),
        orderType: "SALES_ORDER",
      });
      setCommentInput("");
      await fetchOrderComments();
      showSnackbar("Comment added", "success");
    } catch (e) {
      showSnackbar("Failed to add comment", "error");
    } finally {
      setSubmittingComment(false);
    }
  };
  // ─────────────────────────────────────────────────────────────

  // quantityBySpecs arrives from the API as a string ("1"), so coerce before summing —
  // otherwise `acc + item.quantityBySpecs` concatenates and 4x qty 1 renders as "01111".
  // Cap at 5 decimals so float drift (0.1 + 0.2 = 0.30000000000000004) doesn't leak into
  // the UI; Number() then trims trailing zeros so whole counts stay "4", not "4.00000".
  const totalQuantity = Number(
    (
      orderDetails?.baseOrderResponse?.lineItems?.reduce(
        (acc, item) => acc + Number(item?.quantity) || (Number(item?.quantityBySpecs) || 0),
        0
      ) || 0
    ).toFixed(5)
  );

  const billingAddress = [
    orderDetails?.addressEntityModel?.billingAddress?.addressLine1,
    orderDetails?.addressEntityModel?.billingAddress?.addressLine2,
    orderDetails?.addressEntityModel?.billingAddress?.city,
    orderDetails?.addressEntityModel?.billingAddress?.state,
    orderDetails?.addressEntityModel?.billingAddress?.pinCode,
  ]
    .filter(Boolean)
    .join(", ");

  const shippingAddress = [
    orderDetails?.addressEntityModel?.shippingAddress?.addressLine1,
    orderDetails?.addressEntityModel?.shippingAddress?.addressLine2,
    orderDetails?.addressEntityModel?.shippingAddress?.city,
    orderDetails?.addressEntityModel?.shippingAddress?.state,
    orderDetails?.addressEntityModel?.shippingAddress?.pinCode,
  ]
    .filter(Boolean)
    .join(", ");

  const handleReprintBill = () => {
    if (isReprinting) return;
    // B2B (Sales Orders) use a different status chain — skip the retail payment guard
    if (!isSalesOrder && isShowPayButton) {
      showSnackbar("Complete the payment to print bill", "warning");
      return;
    }

    setIsReprinting(true);

    startPrint({
      orderId: pathParams?.id,
      reprint: true,
      skipBill: false,
      skipKot: true,
      onPrintComplete: () => setIsReprinting(false),
      onPrintError: () => {
        setIsReprinting(false);
        showSnackbar("Failed to reprint bill", "error");
      },
    });
  };

  const handleReprintKot = async () => {
    if (isKotReprinting) return;

    setIsKotReprinting(true);

    try {
      await printToken({
        tableId: orderDetails?.baseOrderResponse?.tableId || null,
        tokenNumber: orderDetails?.orderTokenDetails?.tokenNumber,
        tableNumber: orderDetails?.baseOrderResponse?.tableNumber,
        subOrderType: orderDetails?.baseOrderResponse?.subOrderType,
        customerName: orderDetails?.baseOrderResponse?.customerName || "Walk-in Customer",
        orderItems: orderDetails?.baseOrderResponse?.orderItemList,
        comments: orderDetails?.baseOrderResponse?.comments || "N/A",
        layoutName: orderDetails?.baseOrderResponse?.layoutName || null,
        startTime: orderDetails?.baseOrderResponse?.startTime,
        endTime: orderDetails?.baseOrderResponse?.endTime,
      });
      showSnackbar("KOT reprinted successfully", "success");
    } catch (error) {
      showSnackbar("Failed to reprint KOT", "warning");
    } finally {
      setIsKotReprinting(false);
    }
  };

  async function handleViewInvoice() {
    if (isDownloading) return;
    try {
      setIsDownloading(true);
      const blob = await getInvoiceDocument(pathParams?.id);
      const url = window.URL.createObjectURL(blob);
      // Revoke the previous URL if one exists to avoid memory leaks
      if (invoiceBlobUrl) window.URL.revokeObjectURL(invoiceBlobUrl);
      setInvoiceBlobUrl(url);
      setInvoiceViewerOpen(true);
    } catch (e) {
      showSnackbar("Failed to load invoice", "error");
    } finally {
      setIsDownloading(false);
    }
  }

  function handleCloseInvoiceViewer() {
    setInvoiceViewerOpen(false);
    if (invoiceBlobUrl) {
      window.URL.revokeObjectURL(invoiceBlobUrl);
      setInvoiceBlobUrl(null);
    }
  }

  async function handleDownloadInvoice() {
    if (isDownloading) return; // prevent double click

    try {
      setIsDownloading(true);

      const blob = await getInvoiceDocument(pathParams?.id);

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice-${pathParams?.id}.pdf`);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (e) {
      showSnackbar("Failed to Download PDF", "error");
    } finally {
      setIsDownloading(false); // always reset
    }
  }

  return (
    <Navbar>
      <main className="od-page">
        <div className="od-scroll-area">
          <div className="od-scroll-inner">
            {loading ? (
              <div className="od-loading">
                <div className="od-spinner" />
                Loading order details…
              </div>
            ) : (
              <>
                {/* ── Sticky Header ── */}
                <div className="od-header">
                  <div className="od-header-inner">
                    <section
                      onClick={() => navigate(-1)}
                      className="od-back-btn"
                      data-testid="button-order-record-back"
                      aria-label="Back to orders"
                    >
                      <IconArrowLeft />
                    </section>
                    <div className="od-header-title-wrap">
                      <div className="od-header-title-row">
                        <h1 className="od-title" data-testid="text-order-record-title">
                          Order ID {orderDetails?.baseOrderResponse?.orderId}
                        </h1>
                        <span
                          className="od-badge od-badge--delivered"
                          data-testid="status-order-record"
                        >
                          {/* For B2B orders show the fulfillment stage; raw orderStatus
                              can be "PAYMENT_COMPLETED" after payment is recorded which
                              is misleading as a fulfillment badge. */}
                          {isSalesOrder
                            ? currentFulfillmentStatus?.replace(/_/g, " ")
                            : orderDetails?.baseOrderResponse?.orderStatus}
                        </span>
                        {isSalesOrder && (
                          <span className="od-b2b-badge" data-testid="badge-b2b-order">
                            B2B Sales Order
                          </span>
                        )}
                        {isSalesOrder && orderDetails?.baseOrderResponse?.pricingMode && (
                          <span
                            className={`od-pricing-badge od-pricing-badge--${
                              orderDetails.baseOrderResponse.pricingMode === "WHOLESALE"
                                ? "wholesale"
                                : "retail"
                            }`}
                            data-testid="badge-pricing-mode"
                          >
                            {orderDetails.baseOrderResponse.pricingMode === "WHOLESALE"
                              ? "Wholesale"
                              : "Retail"}
                          </span>
                        )}
                      </div>
                    </div>
                    <section className="od-header-actions">
                      {/* print kot */}
                      {retailType === "RESTAURANT" && (
                        <button
                          className="od-action-btn od-action-btn--secondary"
                          onClick={handleReprintKot}
                          data-testid="button-reprint-kot"
                          disabled={isKotReprinting}
                        >
                          <IconReceiptText />
                          {isKotReprinting ? "Reprinting..." : "Reprint KOT"}
                        </button>
                      )}
                      {/* B2B: View Invoice + fulfilment Actions */}
                      {isSalesOrder && (
                        <>
                          {/* View Invoice — available once payment recorded */}
                          <button
                            className="od-action-btn od-action-btn--secondary"
                            onClick={handleViewInvoice}
                            data-testid="button-view-invoice"
                            disabled={isDownloading}
                            title="View Invoice"
                          >
                            <IconReceiptText />
                            {isDownloading ? "Loading…" : "View Invoice"}
                          </button>
                          {/* Three-dot fulfilment actions menu */}
                          {nextB2bStatus && (
                            <div className="od-b2b-menu-wrap">
                              <button
                                className="od-action-btn od-action-btn--secondary od-b2b-menu-trigger"
                                onClick={() => setB2bMenuOpen((o) => !o)}
                                disabled={statusUpdating}
                                data-testid="button-b2b-actions"
                                aria-label="B2B order actions"
                              >
                                <IconDotsVertical />
                                {statusUpdating ? "Updating…" : "Actions"}
                              </button>
                              {b2bMenuOpen && (
                                <>
                                  <div
                                    className="od-b2b-menu-backdrop"
                                    onClick={() => setB2bMenuOpen(false)}
                                  />
                                  <div className="od-b2b-dropdown" role="menu">
                                    <button
                                      className="od-b2b-dropdown-item"
                                      role="menuitem"
                                      onClick={() => handleUpdateStatus(nextB2bStatus)}
                                    >
                                      {STATUS_LABELS[nextB2bStatus]}
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </>
                      )}
                      {/* print bill — shown for both B2C and B2B (Sales Order) */}
                      <button
                        className={`od-action-btn od-action-btn--secondary${
                          !isSalesOrder && isShowPayButton ? " od-action-btn--disabled" : ""
                        }`}
                        onClick={handleReprintBill}
                        data-testid="button-reprint-bill"
                        disabled={isReprinting}
                      >
                        <IconReceiptText />
                        {isReprinting ? "Reprinting..." : "Reprint Bill"}
                      </button>
                      <button
                        className="od-action-btn od-action-btn--primary"
                        onClick={() => setViewBillOpen(true)}
                        data-testid="button-view-bill"
                      >
                        <IconCreditCard />
                        View Bill
                      </button>
                      {/* record payment */}
                      {isShowPayButton && (
                        <button
                          className="od-action-btn od-action-btn--primary"
                          onClick={handleOpenPaymentModal}
                          data-testid="button-pay"
                          disabled={modalLoader || payLoader}
                        >
                          <IconCreditCard />
                          Pay
                        </button>
                      )}
                    </section>
                  </div>
                </div>

                {/* ── Body ── */}
                <div className="od-body">
                  {/* Top row */}
                  <div className="od-top-row">
                    <section className="od-meta-card" aria-label="Order metadata">
                      <div className="od-meta-grid">
                        {[
                          {
                            id: "channel",
                            label: "Channel",
                            value: orderDetails?.baseOrderResponse?.salesChannel || "-",
                            sub: "order source",
                          },
                          {
                            id: "payment-mode",
                            label: "Payment mode",
                            value: orderDetails?.orderBillingDetails?.paymentMethod || "-",
                            sub: "payment source",
                          },
                          {
                            id: "fill-rate",
                            label: "Fill rate",
                            value: `${
                              orderDetails?.baseOrderResponse?.numberOfLineItems || 0
                            } products`,
                            sub: "fulfilled items",
                          },
                          {
                            id: "quantity",
                            label: "Quantity",
                            value: `${totalQuantity} units`,
                            sub: "line total",
                          },
                        ]?.map((cell) => (
                          <div
                            key={cell?.id}
                            className="od-meta-cell"
                            data-testid={`card-order-meta-${cell?.id}`}
                          >
                            <p className="od-meta-label">{cell?.label}</p>
                            <p
                              className="od-meta-value"
                              data-testid={`text-order-meta-${cell?.id}`}
                            >
                              {cell?.value}
                            </p>
                            <p className="od-meta-sub">{cell?.sub}</p>
                          </div>
                        ))}
                      </div>
                    </section>

                    <aside className="od-value-card" aria-label="Order value">
                      <p className="od-value-label">Order Value</p>
                      <p className="od-value-amount" data-testid="text-order-record-value">
                        {getStoreCurrencySymbol()}{orderDetails?.orderBillingDetails?.grandTotal || 0}
                      </p>
                      <dl className="od-value-meta">
                        <p>
                          Order date{" "}
                          <span>
                            {orderDetails?.baseOrderResponse?.createdAt
                              ? format(
                                  getISTDate(orderDetails.baseOrderResponse.createdAt),
                                  "dd MMM, yyyy"
                                )
                              : "N/A"}
                          </span>
                        </p>

                        <p>
                          Promise date
                          <span>N/A</span>
                        </p>

                        <p>
                          Fulfillment time
                          <span>N/A</span>
                        </p>
                      </dl>
                      <button
                        className="od-invoice-btn"
                        data-testid="button-order-record-primary-action"
                        onClick={handleDownloadInvoice}
                        disabled={isDownloading}
                      >
                        {isDownloading ? "Downloading..." : "Download invoice"}
                        {!isDownloading && <IconChevronRight />}
                      </button>
                    </aside>
                  </div>

                  {/* Main grid */}
                  <div className="od-main-grid">
                    {/* Timeline */}
                    <aside className="od-timeline-card" aria-label="Order timeline">
                      <div className="od-timeline-header">
                        <div className="od-timeline-icon">
                          <IconShieldCheck />
                        </div>
                        <div>
                          <p className="od-timeline-header-text-label">Order Timeline</p>
                          <h2 className="od-timeline-header-text-title">Tracking milestones</h2>
                        </div>
                      </div>
                      <div className="od-timeline-list">
                        {(orderTimeLine?.timeLine || [])?.map((item, index) => {
                          const st = (item?.fulfilmentStatus || "").toLowerCase();
                          const timelineIcon = () => {
                            if (st?.includes("created")) return <IconClock3 />;
                            if (st?.includes("success") || st?.includes("payment"))
                              return <IconCreditCard />;
                            if (st?.includes("invoice") || st?.includes("tax"))
                              return <IconReceiptText />;
                            if (st?.includes("deliver")) return <IconCircleCheck />;
                            return <IconShieldCheck />;
                          };
                          const timelineTestId = () => {
                            if (st?.includes("created")) return "timeline-item-order-created";
                            if (st?.includes("success") || st?.includes("payment"))
                              return "timeline-item-payment-success";
                            if (st?.includes("invoice") || st?.includes("tax"))
                              return "timeline-item-tax-invoice-generated";
                            if (st?.includes("deliver")) return "timeline-item-delivered";
                            return `timeline-item-${st?.replace(/\s+/g, "-")}`;
                          };
                          return (
                            <section
                              key={index}
                              className="od-timeline-item"
                              data-testid={timelineTestId()}
                            >
                              <div className="od-timeline-dot">{timelineIcon()}</div>
                              <p className="od-timeline-event-name">
                                {item?.fulfilmentStatus?.replaceAll("_", " ")}
                              </p>
                              <p className="od-timeline-event-by">by {item?.updatedBy || "N/A"}</p>
                              <time className="od-timeline-event-time">
                                {item?.updateAt
                                  ? format(getISTDate(item.updateAt), "dd MMM, yyyy h:mm aa")
                                  : "N/A"}
                              </time>
                            </section>
                          );
                        })}
                      </div>
                      {/* <div className="od-timeline-list">
                    {timelineItems?.map((item) => (
                      <section
                        key={item.id}
                        className="od-timeline-item"
                        data-testid={`timeline-item-${item.id}`}
                      >
                        <div className="od-timeline-dot">{item.icon}</div>
                        <p className="od-timeline-event-name">{item.name}</p>
                        <p className="od-timeline-event-by">by {item.by}</p>
                        <time className="od-timeline-event-time">{item.time}</time>
                      </section>
                    ))}
                  </div> */}
                    </aside>

                    {/* Right column */}
                    <div className="od-right-col">
                      {/* More Order Details */}
                      <section className="od-panel" aria-label="More order details">
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 12,
                          }}
                        >
                          <div>
                            <p className="od-panel-title">More Order Details</p>
                            <p className="od-panel-subtitle">
                              Supporting purchase, billing, and operational metadata.
                            </p>
                          </div>
                        </div>
                        <dl className="od-details-grid">
                          {[
                            {
                              id: "po-date",
                              label: "PO date",
                              value: orderDetails?.poInfo?.poDate || "N/A",
                              sub: "purchase order",
                            },
                            {
                              id: "po-number",
                              label: "PO number",
                              value: orderDetails?.poInfo?.poNumber || "N/A",
                              sub: "reference",
                            },
                            {
                              id: "payment-due-on",
                              label: "Payment due on",
                              value: orderDetails?.poInfo?.paymentDueDate || "N/A",
                              sub: "billing due",
                            },
                            {
                              id: "shipment",
                              label: "Shipment",
                              value: orderDetails?.poInfo?.shipment || "N/A",
                              sub: "dispatch info",
                            },
                            {
                              id: "po-value",
                              label: "PO value",
                              value: `${getStoreCurrencySymbol()}${orderDetails?.poInfo?.poValue || 0}`,
                              sub: "tax inclusive",
                            },
                            {
                              id: "discounts",
                              label: "Discounts",
                              value: `${getStoreCurrencySymbol()}${orderDetails?.orderBillingDetails?.totalDiscount || 0}`,
                              sub: "on this order",
                            },
                            {
                              id: "returns",
                              label: "Returns",
                              value: `${getStoreCurrencySymbol()}${orderDetails?.returnDetails?.refundAmount || 0}`,
                              sub: "from this order",
                            },
                            {
                              id: "additional-expense",
                              label: "Additional expense",
                              value: `${getStoreCurrencySymbol()}${orderDetails?.baseOrderResponse?.additionalExpenses || 0}`,
                              sub: "extra fees",
                            },
                          ]?.map((cell) => (
                            <div
                              key={cell?.id}
                              className="od-meta-cell"
                              data-testid={`card-order-meta-${cell?.id}`}
                            >
                              <dt className="od-meta-label">{cell?.label}</dt>
                              <p
                                className="od-meta-value"
                                data-testid={`text-order-meta-${cell?.id}`}
                              >
                                {cell?.value}
                              </p>
                              <p className="od-meta-sub">{cell?.sub}</p>
                            </div>
                          ))}
                        </dl>
                      </section>

                      {/* Addresses */}
                      <div className="od-address-grid">
                        <section className="od-address-card" aria-label="Billing address">
                          <p className="od-meta-label">Billing Address</p>
                          <address data-testid="text-order-billing-address">
                            {billingAddress || "N/A"}
                          </address>
                        </section>
                        <section className="od-address-card" aria-label="Shipping address">
                          <p className="od-meta-label">Shipping Address</p>
                          <address data-testid="text-order-shipping-address">
                            {shippingAddress || "N/A"}
                          </address>
                        </section>
                      </div>

                      {/* Tab pills */}
                      <nav className="od-tabs-scroll" aria-label="Order detail tabs">
                        <div className="od-tabs-row" role="tablist">
                          {TABS?.map((tab) => (
                            <button
                              key={tab?.id}
                              type="button"
                              role="tab"
                              aria-selected={activeTab === tab?.id}
                              className={`od-tab-btn${
                                activeTab === tab?.id ? " od-tab-btn--active" : ""
                              }`}
                              data-testid={tab?.testId}
                              onClick={() => setActiveTab(tab?.id)}
                            >
                              {tab?.label}
                            </button>
                          ))}
                        </div>
                      </nav>

                      {/* Active tab content */}
                      <div role="tabpanel" className="tabPanel-order">
                        <ActiveComponent orderDetails={orderDetails} />
                      </div>

                      {/* B2B: Comments section */}
                      {isSalesOrder && (
                        <section className="od-comments-section" aria-label="Order comments">
                          <header className="od-comments-header">
                            <h3 className="od-comments-title">Comments</h3>
                            <span className="od-comments-count">
                              {orderComments?.length} note{orderComments?.length !== 1 ? "s" : ""}
                            </span>
                          </header>
                          <div className="od-comments-list">
                            {commentsLoading ? (
                              <p className="od-comments-empty">Loading…</p>
                            ) : orderComments?.length === 0 ? (
                              <p className="od-comments-empty">No comments yet.</p>
                            ) : (
                              orderComments?.map((c) => (
                                <article key={c?.commentId} className="od-comment-item">
                                  <div className="od-comment-meta">
                                    <span className="od-comment-author">
                                      {c?.createdBy || "Staff"}
                                    </span>
                                    <time className="od-comment-time">
                                      {c?.createdAt
                                        ? (() => {
                                            try {
                                              return format(
                                                new Date(c?.createdAt),
                                                "dd MMM yyyy, h:mm aa"
                                              );
                                            } catch {
                                              return c?.createdAt;
                                            }
                                          })()
                                        : ""}
                                    </time>
                                  </div>
                                  <p className="od-comment-text">{c?.comment}</p>
                                </article>
                              ))
                            )}
                          </div>
                          <form
                            className="od-comment-form"
                            onSubmit={(e) => {
                              e.preventDefault();
                              handleSubmitComment();
                            }}
                          >
                            <textarea
                              className="od-comment-input"
                              placeholder="Add a comment…"
                              rows={2}
                              value={commentInput}
                              onChange={(e) => setCommentInput(e.target.value)}
                              disabled={submittingComment}
                            />
                            <button
                              type="submit"
                              className="od-comment-submit"
                              disabled={submittingComment || !commentInput.trim()}
                              data-testid="button-submit-comment"
                            >
                              <IconSend />
                              {submittingComment ? "Posting…" : "Post"}
                            </button>
                          </form>
                        </section>
                      )}
                    </div>
                    {/* end right col */}
                  </div>
                  {/* end main grid */}
                </div>
                {/* end body */}
              </>
            )}
          </div>
        </div>
      </main>

      {viewBillOpen && (
        <BillDrawer
          open={viewBillOpen}
          onClose={() => setViewBillOpen(false)}
          orderId={pathParams?.id}
          orderDetails={orderDetails}
        />
      )}

      {/* Manager PIN gate — shown to non-managers before the payment modal opens */}
      <ManagerPinVerifyModal
        open={showManagerPinGate}
        onClose={() => {
          setShowManagerPinGate(false);
          resetPaymentValues();
        }}
        onSuccess={() => {
          setShowManagerPinGate(false);
          setForceOfflineMode(true);
          setOpenPayModal(true);
        }}
        title="Authorise Offline Payment"
      />

      {/* Payment Modal */}
      <PaymentModal
        openPayModal={openPayModal}
        closePaymentModal={closePaymentModal}
        cartItems={orderDetails?.baseOrderResponse?.lineItems || [{ id: 1 }]}
        forceOfflinePay={forceOfflineMode}
        newLoader={false}
        modalLoader={modalLoader}
        payLoader={payLoader}
        partialStatus={partialStatus}
        paymentMethod={paymentMethod}
        splitActive={splitActive}
        setSplitActive={setSplitActive}
        amtHeading="Amount Due"
        amountDue={amountDue}
        adjustCheck={false}
        amtToBePaid={amountDue}
        setPaymentMethod={setPaymentMethod}
        cashIcon={cashNew}
        cashIconSelected={cashNewSelected}
        upiIcon={upiNew}
        upiIconSelected={upiNewSelected}
        cardIcon={cardNew}
        cardIconSelected={cardNewSelected}
        creditIcon={creditNew}
        creditIconSelected={creditNewSelected}
        storeMode={storeMode}
        handleOffline={handleOffline}
        singleOrderoffline={singleOrderoffline}
        offlineImg={offlineImg}
        splitImg={splitNew}
        splitImgSelected={splitNewSelected}
        handleSplitPayment={handleSplitPayment}
        checkPayment={partialCompletePayment}
        clrAmountFun={clrAmountFun}
        enterAmount={enterAmount}
        setEnterAmount={setEnterAmount}
        enterAmountRef={null}
        cashChange={cashChange}
        handlesplitInputChange={handlesplitInputChange}
        amountPaid={amountPaid}
        functionCalled={functionCalled}
        setFunctionCalled={setFunctionCalled}
        cardFunctionCalled={cardFunctionCalled}
        setCardFunctionCalled={setCardFunctionCalled}
        setSplitFunctionCalled={setSplitFunctionCalled}
        splitFunctionCalled={splitFunctionCalled}
        paymentLoader={paymentLoader}
        paymentLoadingModal={paymentLoadingModal}
        manual={manual}
        transCode={transCode}
        approveloader={approveloader}
        cashierPin={null}
        paymentFailed={paymentFailed}
        newId={pathParams?.id}
        failedImgWarning={failedImgWarning}
        handleTansactionCancel={() => {}}
        cancelLoader={cancelLoader}
        paymentSuccess={paymentSuccess}
        isError={false}
        isPrinting={false}
        orderId={pathParams?.id}
        resetValues={resetPaymentValues}
        paymentCancel={paymentCancel}
        cancelGif={cancelGif}
        handleManual={handleManual}
        newTransId={newTransId}
        setPaymentSuccess={setPaymentSuccess}
        setpaymentLoader={setpaymentLoader}
        partialCompletePayment={partialCompletePayment}
        total={amountDue}
        setOpen={() => {}}
      />
      {/* ── Inline PDF Invoice Viewer ── */}
      {invoiceViewerOpen && (
        <div className="od-invoice-viewer-overlay" role="dialog" aria-label="Invoice viewer">
          <div className="od-invoice-viewer-header">
            <span className="od-invoice-viewer-title">
              Invoice — {orderDetails?.baseOrderResponse?.orderId}
            </span>
            <div className="od-invoice-viewer-actions">
              <button
                className="od-action-btn od-action-btn--secondary"
                onClick={handleDownloadInvoice}
                disabled={isDownloading}
              >
                <IconReceiptText />
                Download
              </button>
              <button
                className="od-invoice-viewer-close"
                onClick={handleCloseInvoiceViewer}
                aria-label="Close invoice viewer"
              >
                ✕ Close
              </button>
            </div>
          </div>
          <embed
            src={invoiceBlobUrl}
            type="application/pdf"
            className="od-invoice-viewer-frame"
            title="Invoice PDF"
          />
        </div>
      )}
    </Navbar>
  );
};

export default OrdersDetailsV2;
